import { BaseMeta } from 'types';

const NumberOfMetasAllowed = 3;

const getSlicedMetas = (
    maxNumberOfMetas: number,
    metas?: BaseMeta[],
): BaseMeta<string>[] | undefined => {
    if (!metas) {
        return undefined;
    }

    const NumberOfAllowedTags = Math.min(
        NumberOfMetasAllowed,
        maxNumberOfMetas,
    );

    const slicedMetas = metas
        ?.filter((meta) => !!meta?.code)
        .slice(0, NumberOfAllowedTags);

    return slicedMetas;
};

export default getSlicedMetas;
